import { render, staticRenderFns } from "./editCTATwitter.vue?vue&type=template&id=091ab9a8&"
import script from "./editCTATwitter.vue?vue&type=script&lang=js&"
export * from "./editCTATwitter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports